// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import WallisAndFutuna from '../_raw/flag/icon_flag_wallis_and_futuna.png';

export default () => <img src={WallisAndFutuna} alt="WallisAndFutuna" />;
